<script>
import debounce from 'lodash.debounce'
import { findDuplicates } from '../services/Accounts'
import AccountTypeField from '../components/Form/AccountTypeField'
import ExpiryDateField from '../components/Form/ExpiryDateField'
import AssessmentModifierField from '../components/Form/AssessmentModifierField'
import AssessmentDateField from '../components/Form/AssessmentDateField'
import DateField from '../components/Form/DateField'
import SkipSchedulingField from '@/components/Form/SkipSchedulingField'
import { Rules } from '../helpers'

export default {
  name: 'AccountMixin',
  components: { AccountTypeField, ExpiryDateField, AssessmentModifierField, AssessmentDateField, DateField, SkipSchedulingField },
  data () {
    return {
      user: {
        'username': null,
        'password': null,
        'expires_at': null,
        'assessment_duration_modifier': null,
        'assessment_skip_scheduling': null,
        'assessment_start_date': null,
        'assessment_end_date': null,
        'assessment_date': null,
        'last_name': null,
        'first_name': null,
        'location': null,
        'assessment_location': null,
        'email': null,
        'is_reusable': false,
        'user_type': null,
        'options': [],
        'assessment_group': null
      },
      duplicateUsernames: [],
      rules: Rules.account,
      checkDuplicates: debounce(() => {
        findDuplicates(this.usernames).then((usernames) => {
          this.duplicateUsernames = usernames
        })
      }, 500)
    }
  },
  computed: {
    usernameErrors () {
      return this.duplicateUsernames.map(username => `Account '${username}' already exists`)
    }
  },
  watch: {
    usernames () {
      this.checkDuplicates()
    }
  }
}
</script>
